import { ColDef } from 'ag-grid-enterprise';
import BtnTrashRenderer from './BtnTrashRenderer';

// 列の定義
export const defaultColDef = {
  resizable: true,
  floatingFilter: false,
  sortable: false,
  enableMenu:false,
  enableSorting: false,
  enableFilter: false,
  pinSubMenu:false,
  rowSelection:'single',
};

export let columns: ColDef[] = [
  { headerName: '', field: 'delbtn', width: 45, suppressSizeToFit:true, cellRenderer: BtnTrashRenderer, menuTabs: [],},
  { headerName: '受注No', field: 'po_desc_num', suppressSizeToFit:true, width: 120, cellStyle: { fontSize: '12px' }, menuTabs: [],},
  { headerName: '送り先名', field: 'destin_name', width: 250, cellStyle: { fontSize: '12px' }, menuTabs: [],},
  { headerName: '得意先名', field: 'customer_name', width: 250, cellStyle: { fontSize: '12px' }, menuTabs: [],},
  { headerName: '商品名', field: 'product_name', width: 300, cellStyle: { fontSize: '12px' }, menuTabs: [],},
  { headerName: '原現計画数', field: 'current_qty', width: 100, cellStyle: { fontSize: '12px' }, menuTabs: [],},
];

export let ngcolumns: ColDef[] = [
  { headerName: '', field: 'dummy', width: 45, suppressSizeToFit:true, menuTabs: [],},
  { headerName: '受注No', field: 'po_desc_num', width: 120, suppressSizeToFit:true, cellStyle: { fontSize: '12px', color: '#FF3366' }, menuTabs: [],},
  { headerName: '', field: 'err_point', width: 150, suppressSizeToFit:true, cellStyle: { fontSize: '12px', color: '#FF3366' }, menuTabs: [],
    valueGetter:function(params){
      return params.data.readNo +"件目/"+params.data.totalcnt+"件にてエラー"
    }
  },
  { headerName: '機械名', field: 'mach_name', width: 200, cellStyle: { fontSize: '12px', color: '#FF3366' }, menuTabs: [],},
  { headerName: '寸法W', field: 'po_width', width: 100, cellStyle: { fontSize: '12px', color: '#FF3366' }, menuTabs: [],},
  { headerName: '寸法H', field: 'po_height', width: 100, cellStyle: { fontSize: '12px', color: '#FF3366' }, menuTabs: [],},
  { headerName: '板厚', field: 'thickness', width: 100, cellStyle: { fontSize: '12px', color: '#FF3366' }, menuTabs: [],},
  { headerName: '送り先名', field: 'destin_name', width: 250, cellStyle: { fontSize: '12px', color: '#FF3366' }, menuTabs: [],},
];